import React, { useState, useContext } from 'react'
import { AuthContext } from '../../contexts/auth'
import { useNavigate } from 'react-router-dom'
import { api, createSessionEmployeeEducationDepartment, EducationDepartamentName } from '../../Api'
import { FiUser, FiLock, FiEye, FiEyeOff, FiAlertCircle, FiExternalLink } from 'react-icons/fi'

import {
    Container,
    Brand,
    ContextBadge,
    BrandMark,
    BrandBody,
    BrandTitle,
    BrandSubtitle,
    BrandFoot,
    FormSide,
    InputArea,
    FormHeading,
    FormTitle,
    FormHint,
    Field,
    Area,
    Input,
    EyeButton,
    Btt,
    AccessTopButton,
    ErrorBanner
} from './style'

import {
    SignMessageButton,
    SignMessageButtonText,
    SignMessageButtonTextBold
} from '../../components/Buttons'

import { AtomLogo } from '../../components/AtomLogo'
import { InstallAppButton } from '../../components/InstallAppButton';

import LoadingSpinner from '../../components/Loading'

const SignInEmployeeEducationDepartment = () => {
    const navigate = useNavigate()
    const { loginEmployeeEducationDepartment } = useContext(AuthContext)
    const [cpf, setCpf] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const canSubmit = cpf.trim().length > 0 && password.trim().length > 0 && !loading

    const SignClick = async (e) => {
        if (e && e.preventDefault) e.preventDefault()
        if (!canSubmit) return

        setErrorMessage('')
        setLoading(true)
        try {
            const response = await createSessionEmployeeEducationDepartment(cpf, password)
            if (response) {
                const now = Date.now()
                localStorage.setItem('lastLogin', now)

                const IdEmployee = response.data.id
                const loggedEmployee = response.data.CPF
                const token = response.data.token
                const name = response.data.name
                const type = response.data.type
                const positionAtEducationDepartment = response.data.positionAtEducationDepartment
                const idEducationDepartment = response.data.idEducationDepartment
                const educationDepartment = await EducationDepartamentName(idEducationDepartment)

                sessionStorage.setItem('idDepartment', idEducationDepartment)
                sessionStorage.setItem('name-department', educationDepartment.data.data)
                localStorage.setItem('Id_employee', JSON.stringify(IdEmployee))
                sessionStorage.setItem('cpf', loggedEmployee)
                sessionStorage.setItem('name', name)
                localStorage.setItem('name', name)
                localStorage.setItem('type', type)
                localStorage.setItem('positionAtEducationDepartment', positionAtEducationDepartment)
                localStorage.setItem('token', token)
                sessionStorage.setItem('token', token)

                api.defaults.headers.Authorization = `Bearer ${token}`
                loginEmployeeEducationDepartment(loggedEmployee)
                window.location.reload()
            } else {
                setErrorMessage('CPF ou senha incorretos. Verifique e tente novamente.')
                setLoading(false)
            }
        } catch (err) {
            console.error('Erro ao entrar:', err)
            setErrorMessage('Não foi possível entrar. Confira seus dados e a conexão, e tente novamente.')
            setLoading(false)
        }
    }

    const maskCPF = (value) => {
        return value
            .replace(/\D/g, '')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
            .slice(0, 14)
    }

    const handleChange = (e) => {
        setCpf(maskCPF(e.target.value))
        if (errorMessage) setErrorMessage('')
    }

    if (loading) {
        return <LoadingSpinner />
    }

    return (
        <Container>
            <Brand>
                <BrandMark>
                    <AtomLogo size={48} nucleus="#ffffff" />
                    <span>Diário Escolar Virtual</span>
                </BrandMark>

                <BrandBody>
                    <ContextBadge>Secretaria de Educação</ContextBadge>
                    <BrandTitle>Portal da SEMED</BrandTitle>
                    <BrandSubtitle>
                        Acesso da Secretaria Municipal de Educação para gestão da rede,
                        acompanhamento das escolas e indicadores educacionais.
                    </BrandSubtitle>
                </BrandBody>

                <BrandFoot>
                    Ambiente Integrado de Gestão Escolar
                </BrandFoot>
            </Brand>

            <FormSide>
                <InputArea onSubmit={SignClick}>
                    <AccessTopButton
                        type="button"
                        onClick={() => navigate('/signin/employee')}
                    >
                        <FiExternalLink size={15} /> Acessar Instituição de Ensino
                    </AccessTopButton>

                    <FormHeading>
                        <FormTitle>Entrar na SEMED</FormTitle>
                        <FormHint>Acesso exclusivo da Secretaria de Educação.</FormHint>
                    </FormHeading>

                    {errorMessage && (
                        <ErrorBanner role="alert">
                            <FiAlertCircle size={16} /> {errorMessage}
                        </ErrorBanner>
                    )}

                    <Field>
                        CPF
                        <Area $error={!!errorMessage}>
                            <FiUser size={18} />
                            <Input
                                placeholder="000.000.000-00"
                                value={cpf}
                                onChange={handleChange}
                                type="text"
                                inputMode="numeric"
                                autoComplete="username"
                                maxLength="14"
                            />
                        </Area>
                    </Field>

                    <Field>
                        Senha
                        <Area $error={!!errorMessage}>
                            <FiLock size={18} />
                            <Input
                                placeholder="Digite sua senha"
                                value={password}
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                onChange={(e) => { setPassword(e.target.value); if (errorMessage) setErrorMessage('') }}
                            />
                            <EyeButton
                                type="button"
                                onClick={() => setShowPassword(s => !s)}
                                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                title={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                            >
                                {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </EyeButton>
                        </Area>
                    </Field>

                    <Btt type="submit" disabled={!canSubmit}>Entrar</Btt>

                    <SignMessageButton type="button" onClick={() => navigate('/forgot-password-education-department')}>
                        <SignMessageButtonText>Esqueceu sua</SignMessageButtonText>
                        <SignMessageButtonTextBold>senha?</SignMessageButtonTextBold>
                    </SignMessageButton>

                    <InstallAppButton variant="login" />
                </InputArea>
            </FormSide>
        </Container>
    )
}

export default SignInEmployeeEducationDepartment